export enum QueryKeys {
  fetchTreatmentTemplateDetails = "fetchTreatmentTemplateDetails",
  fetchProgressData = "fetchProgressData",
  fetchPatient = "fetchPatient",
  fetchActiveTreatment = "fetchActiveTreatment",
  fetchTherapist = "fetchTherapist",
  fetchSessionFeedback = "fetchSessionFeedback",
  fetchNextSession = "fetchNextSession",
  fetchSessionRecap = "fetchSessionRecap",
  fetchSound = "fetchSound",
  fetchDisplayHappinessQuestionnaire = "fetchDisplayHappinessQuestionnaire",
  fetchReleaseNotes = "fetchReleaseNotes",
  sendSessionFeedbackReaction = "sendSessionFeedbackReaction",
  sendRoutineFeedbackReaction = "sendRoutineFeedbackReaction",
  cancelPaymentSubscription = "cancelPaymentSubscription",
  renewPaymentSubscription = "renewPaymentSubscription",
  updatePaymentMethod = "updatePaymentMethod",
}
